export class Version {
	readonly major: number = 0;
	readonly minor: number = 0;
	readonly point: number = 0;

	constructor(version?: string | null) {
		if (version) {
			const split = version.split(".");
			if (split.length === 3) {
				this.major = +split[0];
				this.minor = +split[1];
				this.point = +split[2];
			} else {
				console.warn("Unable to convert version.", version);
			}
		}
	}

	isGreterOrEqualToo = (version: Version) => {
		if (this.major >= version.major) {
			if (this.major > version.major) {
				return true;
			} else {
				if (this.minor >= version.minor) {
					if (this.minor > version.minor) {
						return true;
					} else {
						if (this.point >= version.point) {
							return true;
						}
					}
				}
			}
		}

		return false;
	};

	toString = () => {
		return `${this.major}.${this.minor}.${this.point}`;
	};
}
